// Open reviews when plugin widget is clicked
document.querySelector(".jdgm-widget").addEventListener("click", function() {
    openAccordion("reviews");
})

// Increase review plugin star size + add score
const starsElement = document.querySelector(".jdgm-prev-badge__stars");
const injectScore = () => {
    const score = starsElement.getAttribute("data-score");
    console.log(score);
    starsElement.parentElement.innerHTML = 
    "<span class='font-title text-4xl'>" + 
    score + 
    "</span>" + 
    starsElement.parentElement.innerHTML;
}

// Add SVG into subtext
const injectSVG = async () => {
    const subtextElement = document.querySelector(".jdgm-prev-badge__text");
    const content = subtextElement.innerHTML;
    const reviews = content.split(" ")[1];
    
    setTimeout(() => {
        subtextElement.innerHTML = `Based on ${reviews} <svg width='16' height='16' viewBox='0 0 17 16' fill='none' xmlns='http://www.w3.org/2000/svg' style='display: inline-block;'><path fill-rule='evenodd' clip-rule='evenodd' d='M16.17 7.06023L15.09 5.72023C14.92 5.50023 14.81 5.24023 14.78 4.95023L14.59 3.25023C14.5514 2.91078 14.3989 2.59443 14.1574 2.35286C13.9158 2.11129 13.5994 1.95878 13.26 1.92023L11.56 1.73023C11.26 1.70023 11 1.57023 10.78 1.40023L9.43999 0.320234C8.88999 -0.119766 8.10999 -0.119766 7.55999 0.320234L6.21999 1.40023C5.99999 1.57023 5.73999 1.68023 5.44999 1.71023L3.74999 1.90023C3.04999 1.98023 2.49999 2.53023 2.41999 3.23023L2.22999 4.93023C2.19999 5.23023 2.06999 5.49023 1.89999 5.71023L0.81999 7.05023C0.37999 7.60023 0.37999 8.38023 0.81999 8.93023L1.89999 10.2702C2.06999 10.4902 2.17999 10.7502 2.20999 11.0402L2.39999 12.7402C2.47999 13.4402 3.02999 13.9902 3.72999 14.0702L5.42999 14.2602C5.72999 14.2902 5.98999 14.4202 6.20999 14.5902L7.54999 15.6702C8.09999 16.1102 8.87999 16.1102 9.42999 15.6702L10.77 14.5902C10.99 14.4202 11.25 14.3102 11.54 14.2802L13.24 14.0902C13.94 14.0102 14.49 13.4602 14.57 12.7602L14.76 11.0602C14.79 10.7602 14.92 10.5002 15.09 10.2802L16.17 8.94023C16.61 8.39023 16.61 7.61023 16.17 7.06023ZM6.99999 12.0002L3.49999 8.50023L4.99999 7.00023L6.99999 9.00023L12 4.00023L13.5 5.55023L6.99999 12.0002Z' fill='black'/></svg> Verified Customer reviews`;
    }, 500);
}
document.addEventListener("DOMContentLoaded", function() {
    injectScore();
    injectSVG();
    
    if(document.querySelector(".jdgm-widget .font-title")) openAccordion("reviews");
});